export const PREVIEW_PAGE_SIZE = 5;

export const getCollectionRows = (payload) => {
  if (Array.isArray(payload)) return payload;
  for (const key of ["data", "records", "items", "badges"]) {
    if (Array.isArray(payload?.[key])) return payload[key];
  }
  return [];
};

export const paginatePreviewRows = (rows, page = 0) => ({
  rows: rows.slice(page * PREVIEW_PAGE_SIZE, (page + 1) * PREVIEW_PAGE_SIZE),
  total: rows.length,
  pageCount: Math.ceil(rows.length / PREVIEW_PAGE_SIZE),
  pageSize: PREVIEW_PAGE_SIZE,
});

// Some existing endpoints use a fixed page size, even when limit is requested.
// Preserve all returned rows and remember that size for subsequent page ranges.
export const getServerPreviewPage = (payload, page, mapRow, fallbackTotal, previousPageSize) => {
  const records = getCollectionRows(payload);
  const total = Number(payload?.totalItems ?? payload?.total ?? payload?.count ?? fallbackTotal ?? records.length);
  const pageSize = Number(payload?.limit ?? payload?.pageSize) ||
    (page > 0 ? previousPageSize : records.length) || PREVIEW_PAGE_SIZE;
  const pageCount = Number(payload?.totalPages) || Math.ceil(total / pageSize);
  return { rows: records.map(mapRow), total, pageCount, pageSize };
};
